export enum TransportManagementProfileEndpoint {
  Base = '/transport-management',
  Default = '/default',
  Profiles = '/profiles',
  Clone = '/clone',
  Profile = '/profile',
  Report = '/report',
  Fields = '/fields',
  Usage = '/usage',
}
